import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=ec3195f2&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=ec3195f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3195f2",
  null
  
)

export default component.exports